<section class="w-full">
  <split-header-section title="Repasses Profissionais"></split-header-section>

  <div>
    <split-filter-menu [filterBySplit]="true" (filterEvent)="addFilterOptions($event)"></split-filter-menu>
  </div>

  <form class="w-full mt-5" [formGroup]="form" [style.padding-left]="'16.002px'" [style.padding-right]="'16.002px'">
    <div class="grid mt-5">
      <div class="col-8 hidden">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="mb-5">
             <split-text theme="secondery" title="Acompanhamento mês a mês" subtitle="Últimos 12 meses">
          </split-text>
          </div>

          <div class="grid p-fluid">
            <div class="col">
              <div class="w-full relative">
                <split-loading [loading]="loadingChart"></split-loading>
                <split-line *ngIf="showChart" [data]="form.value.chart_data" [labels]="form.value.chart_label!"
                  [allowLegend]="true" [highlightLastLabel]="false" [reduceLabels]="true"></split-line>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-4 hidden">
        <split-card theme="secondary">
          <ng-container card-header>
            <div class="flex justify-content-between align-items-center">
                <split-text theme="secondery" title="Valores totais" subtitle="Com base na data selecionada">
                </split-text>
            </div>
          </ng-container>
          <ng-container card-body>
            <div class="relative flex align-items-center justify-content-center w-full">
            <ng-container *ngIf="!loadingTotalAmount; else loading">
            <div class="w-full h-full flex flex-column gap-2 align-items-center">
              <split-report-message class="w-full" [width]="'100%'" [value]="(form.value.faturamento_total)!"
                [label]="'Faturamento total'" [bgColor]="'rgba(10, 131, 0, 0.08)'"
                [borderColor]="'rgba(10, 131, 0, 1)'" [disableBorder]="true"></split-report-message>
              <split-report-message  class="w-full" [width]="'100%'" [value]="(form.value.receita_profissional)!"
                [label]="'Repasse do Profissional'" [bgColor]="'rgba(0, 74, 160, 0.08)'"
                [borderColor]="'#004AA0'" [disableBorder]="true"></split-report-message>
              <split-report-message  class="w-full" [width]="'100%'" [value]="(form.value.receita_empresa)!"
                [label]="'Repasse da Empresa'" [bgColor]="'rgba(255, 131, 33, 0.08)'"
                [borderColor]="'#FF8321'" [disableBorder]="true"></split-report-message>
            </div>
           </ng-container>
           <ng-template #loading>
            <div class="loading">
              <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
            </div>
           </ng-template>
          </div>
          </ng-container>
        </split-card>
      </div>
    </div>

    <div class="grid mt-5 relative">
      <div class="col">
        <div class="bg-white p-5 border-round-2xl box-shadow">
          <div class="header mb-6 flex justify-content-between">
            <div>
              <span class="title"> Listagem dos profissionais </span> <br />
            </div>
            <div class="flex align-items-center">
              <split-group-filter (onFilterEvent)="onFilterChange($event)">
                <split-filter-professional field="professional" label="Profissional" key="professional"></split-filter-professional>
            </split-group-filter>
            </div>
          </div>
          <ng-container *ngIf="!loadingProfessionals; else loading">
          <div class="mt-5">
            <div class=" table">
              <split-table [dados]="form.value.listagem_profissionais!" [loading]="loadingProfessionals" [widthColumns]="[10, 2, 3, 10, 10, 10, 10, 10, 10, 10]">
                <ng-template #parentHeader>
                  <th colspan="4"></th>
                  <th colspan="4">Profissional</th>
                  <th colspan="1">Unidade</th>
                  <th colspan="1"></th>
                </ng-template>

                
                <ng-template #header>
                  <div class="text-left pl-3">Profissional</div>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                  <div class="text-left add_ellipsis pl-3 ">
                    <span class="primary">
                      {{ item.professionalName }}
                    </span>
                  </div>
                </ng-template>
                <ng-template #header>Atendimentos</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                  {{ item.appointment }}
                </ng-template>

                <ng-template #header>Split</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                  {{ item.split ? 'Sim' : 'Não'}}
                </ng-template>

                <ng-template #header>
                  <split-tooltip-text text="Total Receitas" tooltipText="Receita total clinica + Receita total Profissional."></split-tooltip-text>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                  {{item.revenueTotalAmount | currency:'BRL':'symbol':'1.2-2'}}
                </ng-template>

                <ng-template #header>
                    <split-tooltip-text text="Ganho projetado" tooltipText="Quanto é estimado para recebimento do profissional com base no período de atendimentos selecionados."></split-tooltip-text>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                  {{item.estimatedProfessionalAmount | currency:'BRL':'symbol':'1.2-2'}}
                </ng-template>


                <ng-template #header>
                  <split-tooltip-text text="Repasse recebido" tooltipText="Quanto o profissional já recebeu no intervalo selecionado."></split-tooltip-text>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{item.effectiveProfessionalAmount | currency:'BRL':'symbol':'1.2-2'}}
                </ng-template>

                <ng-template #header>
                  <split-tooltip-text text="Saldo do mês" tooltipText="Quanto o profissional deveria receber com base na data selecionada."></split-tooltip-text>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{ item.pendingProfessionalAmount | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>

                <ng-template #header>
                   <split-tooltip-text text="Saldo acumulado" tooltipText="Quanto o profissional deveria receber com base no período total de tempo. Saldo total de todos os meses a receber."></split-tooltip-text>
                </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{ item.professionalBalance | currency:'BRL':'symbol':'1.2-2' }}
                </ng-template>


                <ng-template #header>Ganho projetado</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{item.estimatedClinicAmount | currency:'BRL':'symbol':'1.2-2'}}
                </ng-template>

                <!--<ng-template #header>Repasse empresa</ng-template>
                <ng-template #coluna let-item="dadosLinha">
                    {{item.effectiveClinicAmount | currency:'BRL':'symbol':'1.2-2'}}
                </ng-template>-->

                <ng-template #header> </ng-template>
                <ng-template #coluna let-item="dadosLinha">
                   <p-button [rounded]="true" severity="secondary" [text]="true" (click)="openReportByProfessional(item.professionalName, item.professionalId)">
                        <ng-template pTemplate="icon">
                            <div class="flex">
                              <split-icon name="playlist-add" size="24px"></split-icon>
                            </div>
                        </ng-template>
                    </p-button>
                </ng-template>
              </split-table>
            </div>
          </div>

          <split-total-table [widthColumns]="[10, 5, 5, 10, 10, 10, 10, 10, 10, 10]">
            <ng-template #column>
             <span class="primary ml-3">Todos</span>
            </ng-template>
             <ng-template #column>
              {{ form.value.total_listagem_profissionais?.totalAppointment }}
            </ng-template>
             <ng-template #column>
              -
            </ng-template>
             <ng-template #column>
              {{ form.value.total_listagem_profissionais?.revenueTotalAmount | currency:'BRL':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template #column>
               {{ form.value.total_listagem_profissionais?.estimatedProfessionalAmount |
                    currency:'BRL':'symbol':'1.2-2' }}
            </ng-template>
            <ng-template #column>
               {{ form.value.total_listagem_profissionais?.effectiveProfessionalAmount |
                    currency:'BRL':'symbol':'1.2-2'}}
            </ng-template>
            <ng-template #column>
              {{ form.value.total_listagem_profissionais?.pendingProfessionalAmount |
                    currency:'BRL':'symbol':'1.2-2' }}
            </ng-template>
             <ng-template #column>
                 {{ form.value.total_listagem_profissionais?.professionalBalance | currency:'BRL':'symbol':'1.2-2'}}
            </ng-template>
            <ng-template #column>
                 {{ form.value.total_listagem_profissionais?.estimatedClinicAmount | currency:'BRL':'symbol':'1.2-2'}}
            </ng-template>
             <!--<ng-template #column>
                 {{ form.value.total_listagem_profissionais?.effectiveClinicAmount | currency:'BRL':'symbol':'1.2-2'}}
            </ng-template>-->
           <ng-template #column> </ng-template>
          </split-total-table>
        </ng-container>
        <ng-template #loading>
          <div class="loading">
            <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
          </div>
        </ng-template>
        </div>
      </div>
    </div>
  </form>
</section>